import {
  Conditional,
  MyEquipmentList,
  MyEquipmentVirtualScrollList
} from 'components/pcc-components';
import styles from '../../../customer-account.module.scss';
import { Equipment } from 'services/equipment/types';
import { selectEquipment } from 'services/equipment/actions';
import { RegisterSignInButtonToast } from 'components/my-equipment/equipment-toast/register-signin-button-toast';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';
import { useQuickToast } from 'hooks/use-toast';
import { useTranslations } from 'next-intl';
import { useFeedback } from 'providers/feedback-provider';
import { EquipmentListProps } from '../../../types';
import { ServiceInsightIconWrapper } from '../../service-insight-icon-wrapper/service-insight-icon-wrapper';
import { useCallback } from 'react';

export const EquipmentList = ({
  equipmentList,
  selectedEquipment,
  userDetail,
  searchTerm,
  serviceInsights,
  setSearchInput,
  isVirtualScrollFeatureEnabled,
  startTransition
}: Readonly<EquipmentListProps>) => {
  const t = useTranslations();
  const toast = useQuickToast();
  const { dismissFeedback, updateFeedback } = useFeedback();
  const { isLoggedIn } = userDetail;
  const onEquipmentSelected = useCallback(
    async (equipment: Equipment) => {
      try {
        const { model, serialNumber, id, productFamily } = equipment;
        const { serialNumber: selectedSerialNumber = '', id: productId = '' } =
          selectedEquipment || {};
        if (id === productId && serialNumber === selectedSerialNumber) {
          return;
        }
        dismissFeedback();
        startTransition(async () => {
          await selectEquipment(id, serialNumber);
        });
        setSearchInput('');
        const contentGuestToast = !isLoggedIn ? (
          <RegisterSignInButtonToast
            signInText={t('SIGN_IN')}
            registerText={t('SL_REGISTER')}
            guestSaveText={t('GUEST_EQUIPMENT_SAVE')}
          />
        ) : null;
        toast.success({
          message: t('CURRENTLY_SHOPPING', {
            0: model,
            1: capitalizeText(productFamily)
          }),
          content: contentGuestToast,
          delay: 5
        });
      } catch (error) {
        updateFeedback(t('UNKNOWN_ERROR_MESSAGE'));
      }
    },
    [
      selectedEquipment,
      dismissFeedback,
      setSearchInput,
      isLoggedIn,
      t,
      toast,
      updateFeedback,
      startTransition
    ]
  );
  return (
    <div className={styles['equipment-list-wrapper']}>
      <Conditional
        test={isVirtualScrollFeatureEnabled}
        fallback={
          <MyEquipmentList
            searchTerm={searchTerm}
            list={equipmentList}
            selectedEquipment={selectedEquipment}
            onEqpuipmentSelect={onEquipmentSelected}
          >
            {(equip: Equipment) => (
              <ServiceInsightIconWrapper
                equipment={equip}
                selectedEquipment={selectedEquipment}
                userDetail={userDetail}
                serviceInsights={serviceInsights}
              />
            )}
          </MyEquipmentList>
        }
      >
        <MyEquipmentVirtualScrollList
          list={equipmentList}
          searchTerm={searchTerm}
          selectedEquipment={selectedEquipment}
          onEquipmentSelect={onEquipmentSelected}
          isCustomerAccountSection
        >
          {(equip: Equipment) => (
            <ServiceInsightIconWrapper
              equipment={equip}
              selectedEquipment={selectedEquipment}
              userDetail={userDetail}
              serviceInsights={serviceInsights}
            />
          )}
        </MyEquipmentVirtualScrollList>
      </Conditional>
    </div>
  );
};
